// src/apis/OrganizationsApi.ts
import { OrganizationDto } from '../generated-types/organizationDto';
import { AbstractApi } from './AbstractApi';

/**
 * An API to handle organization-related requests.
 */
export default class OrganizationsApi extends AbstractApi {
  /**
   * Fetch all organizations.
   * Currently, this method returns stubbed data.
   */
  async GetAll(): Promise<OrganizationDto[]> {
    // In a real API call, use:
    const response = await this.authFetch(this.BuildUrl('organizations'), {
      method: 'GET',
    });
    if (!response.ok) throw new Error('Failed to load organizations');
    const orgs = (await response.json()) as unknown as OrganizationDto[];
    for (const org of orgs) {
      org.subscriptionStatus.endOfPeriod = new Date(
        org.subscriptionStatus.endOfPeriod
      );
    }

    return orgs;
  }

  /**
   * Archive the specified organization.
   * Archiving should only be permitted for organizations with inactive or no contracts.
   * @param orgId The identifier of the organization to archive.
   */
  async Archive(orgId: string): Promise<void> {
    // In a real API call, use:
    // const response = await this.authFetch(this.BuildUrl(`organizations/${orgId}/archive`), {
    //   method: 'POST'
    // });
    // if (!response.ok) throw new Error('Failed to archive organization');

    // Stubbed response
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log(`Archiving ${orgId}`);
        resolve();
      }, 500);
    });
  }
}
